<template>
  <div>
    <imports-loader
      :account-id="accountId"
      :filters="filters"
      :result="{ items: imports, total: pagination.rowsNumber }"
      @loaded="onLoaded"
    />
    <q-table
      :columns="columns"
      :rows="imports"
      v-model:pagination="pagination"
      v-bind="$attrs"
      wrap-cells
      @request="pagination = $event.pagination"
    >
      <template v-slot:body-cell-startedAt="props">
        <q-td :props="props">
          <span v-if="props.row.startedAt">
            {{ $filters.datetime(props.row.startedAt) }}
          </span>
          <q-icon v-else name="fa fa-spinner fa-spin" />
        </q-td>
      </template>
      <template v-slot:body-cell-completedAt="props">
        <q-td :props="props">
          <span v-if="props.row.completedAt" >
            {{ $filters.datetime(props.row.completedAt) }}
          </span>
          <span v-else>N/A</span>
        </q-td>
      </template>
      <template v-slot:body-cell-status="props">
        <q-td :props="props">
          <import-status-icon :post-import="props.row" />
        </q-td>
      </template>
      <template v-slot:body-cell-actions="props">
        <q-td :props="props">
          <file-name-dropdown v-if="props.row.fileName" :file-name="props.row.fileName" />
          <download-file-btn :post-import-id="props.row.id" flat />
        </q-td>
      </template>
      <template v-slot:no-data>
        <message type="info" class="full-width q-my-sm">
          No post imports found.
        </message>
      </template>
    </q-table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  CollectionFilters,
  QTablePagination,
  QueryResult,
} from '@/type';
import { PostImport } from '@/social/types';
import Message from '@/components/message/Message.vue';
import ImportsLoader from './ImportsLoader.vue';
import ImportStatusIcon from './status/ImportStatusIcon.vue';
import DownloadFileBtn from './file/DownloadFileBtn.vue';
import FileNameDropdown from './file/FileNameDropdown.vue';

interface Data {
  columns: object[],
  pagination: QTablePagination,
  imports: PostImport[],
}

export default defineComponent({
  components: {
    FileNameDropdown,
    DownloadFileBtn,
    ImportStatusIcon,
    Message,
    ImportsLoader,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      columns: [
        {
          name: 'startedAt',
          label: 'Started',
          field: 'startedAt',
          align: 'left',
        },
        {
          name: 'completedAt',
          label: 'Finished',
          align: 'left',
        },
        {
          name: 'status',
          label: 'Status',
          align: 'center',
        },
        {
          name: 'numPosts',
          label: 'No. Posts',
          field(postImport: PostImport) {
            if (postImport.completedAt !== null) return postImport.numPosts;
            return 'N/A';
          },
          align: 'center',
        },
        {
          name: 'actions',
          label: '',
          align: 'right',
        },
      ],
      pagination: {
        page: 1,
        rowsPerPage: 5,
        rowsNumber: 0,
      },
      imports: [],
    };
  },
  computed: {
    filters(): CollectionFilters {
      return {
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    onLoaded(result: QueryResult) {
      this.imports = (result.items as PostImport[]);
      this.pagination.rowsNumber = result.total;
    },
  },
});
</script>
